import { useMediaQuery } from '@helpers/hooks'
import Translations from '@helpers/translations'
import { Button } from '@components/ui/Button'
import Title from '@components/ui/type/Title'
import Modal from '@components/ui/Modal'
import styles from './styles.module.scss'

type ReturnsNoteModalProps = {
  onClose: () => void
}

function ReturnsNoteModal({ onClose }: ReturnsNoteModalProps) {
  const isLargeViewport = useMediaQuery({ minWidth: 840 })
  return (
    <Modal
      onClose={onClose}
      content={
        <div className={styles.returnsModal} data-selector="returns-note-modal">
          <div className={styles.returnsModal__content}>
            <Title
              type="h2"
              text={Translations.localise(
                'pages.returns.return-note-modal-title'
              )}
              classes="title title--left title--returns-title"
            />
            <p className={styles.returnsModal__message}>
              {Translations.localise('pages.returns.return-note-modal-message')}
            </p>
            <Button
              variant="primary"
              size={isLargeViewport ? 'large' : 'small'}
              onClick={onClose}
            >
              {Translations.localise('pages.returns.got-it')}
            </Button>
          </div>
        </div>
      }
      openedModal
    />
  )
}

export default ReturnsNoteModal
